import React, { Component } from 'react';

class Homepage extends Component {
  render() {
    return (
      <div>
        Home
      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/containers/Homepage/Homepage.js